import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../theme';

const useStyles = (secondaryColor = colorsPalette.gray) =>
  makeStyles(() =>
    createStyles({
      element: {
        fill: 'none',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '2',
      },
      elementFill: {
        fill: secondaryColor,
        fillRule: 'evenodd',
      },
    }),
  );

export default useStyles;
